import React from "react";
import Loadable from "react-loadable";

// rct page loader
import RctPageLoader from "../RctPageLoader/RctPageLoader";

const AsyncHomeComponent = Loadable({
  loader: () => import("../../routes/home"),
  loading: () => <RctPageLoader />,
});
const AsyncTranslationsComponent = Loadable({
  loader: () => import("../../routes/translations"),
  loading: () => <RctPageLoader />,
});
const AsyncManageCompaniesComponent = Loadable({
  loader: () => import("../../routes/insurance-companies/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddCompanyComponent = Loadable({
  loader: () => import("../../routes/insurance-companies/create"),
  loading: () => <RctPageLoader />,
});
const AsyncModifyCompanyComponent = Loadable({
  loader: () => import("../../routes/insurance-companies/modify"),
  loading: () => <RctPageLoader />,
});
const AsyncSetPricesComponent = Loadable({
  loader: () => import("../../routes/insurance-companies/set-prices"),
  loading: () => <RctPageLoader />,
});

const AsyncManageInsuranceRequestsComponent = Loadable({
  loader: () => import("../../routes/insurance-requests/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddInsuranceRequestComponent = Loadable({
  loader: () => import("../../routes/insurance-requests/create"),
  loading: () => <RctPageLoader />,
});
const AsyncGetReceivedInsuranceRequestsComponent = Loadable({
  loader: () => import("../../routes/insurance-requests/view-received"),
  loading: () => <RctPageLoader />,
});

const AsyncManageAgenciesComponent = Loadable({
  loader: () => import("../../routes/agencies/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddAgencyComponent = Loadable({
  loader: () => import("../../routes/agencies/create"),
  loading: () => <RctPageLoader />,
});
const AsyncModifyAgencyComponent = Loadable({
  loader: () => import("../../routes/agencies/modify"),
  loading: () => <RctPageLoader />,
});
const AsyncAgencyRatioHistoryComponent = Loadable({
  loader: () => import("../../routes/agencies/ratio-history"),
  loading: () => <RctPageLoader />,
});

/* agency lists */
const AsyncManageAgencyListsComponent = Loadable({
  loader: () => import("../../routes/agency-lists/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncCreateAgencyListComponent = Loadable({
  loader: () => import("../../routes/agency-lists/create"),
  loading: () => <RctPageLoader />,
});
const AsyncModifyAgencyListComponent = Loadable({
  loader: () => import("../../routes/agency-lists/modify"),
  loading: () => <RctPageLoader />,
});

const AsyncManageRolesComponent = Loadable({
  loader: () => import("../../routes/roles/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddRoleComponent = Loadable({
  loader: () => import("../../routes/roles/create"),
  loading: () => <RctPageLoader />,
});
const AsyncModifyRoleComponent = Loadable({
  loader: () => import("../../routes/roles/modify"),
  loading: () => <RctPageLoader />,
});

const AsyncManageUsersComponent = Loadable({
  loader: () => import("../../routes/users/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddUserComponent = Loadable({
  loader: () => import("../../routes/users/create"),
  loading: () => <RctPageLoader />,
});
const AsyncModifyUserComponent = Loadable({
  loader: () => import("../../routes/users/modify"),
  loading: () => <RctPageLoader />,
});
const AsyncUsersLogsComponent = Loadable({
  loader: () => import("../../routes/users/view-logs"),
  loading: () => <RctPageLoader />,
});
const AsyncUsersProfileComponent = Loadable({
  loader: () => import("../../routes/users/profile"),
  loading: () => <RctPageLoader />,
});
const AsyncUsersViewAllUsersLoggedDevicesComponent = Loadable({
  loader: () => import("../../routes/users/view-all-users-logged-devices"),
  loading: () => <RctPageLoader />,
});

const AsyncManageBalanceRequestsComponent = Loadable({
  loader: () => import("../../routes/balance-requests/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddBalanceRequestComponent = Loadable({
  loader: () => import("../../routes/balance-requests/create"),
  loading: () => <RctPageLoader />,
});
const AsyncModifyBalanceRequestComponent = Loadable({
  loader: () => import("../../routes/balance-requests/modify"),
  loading: () => <RctPageLoader />,
});

const AsyncManageFinancialRequestsComponent = Loadable({
  loader: () => import("../../routes/financial-requests/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncSimpleFinancialRequestsComponent = Loadable({
  loader: () => import("../../routes/financial-requests/view-simple"),
  loading: () => <RctPageLoader />,
});
const AsyncExportedFinancialRequestsComponent = Loadable({
  loader: () => import("../../routes/financial-requests/view-exported"),
  loading: () => <RctPageLoader />,
});

const AsyncManageProfitsComponent = Loadable({
  loader: () => import("../../routes/profits/view-all"),
  loading: () => <RctPageLoader />,
});

const AsyncIncomingMoneyReportComponent = Loadable({
  loader: () => import("../../routes/reports/incoming-money"),
  loading: () => <RctPageLoader />,
});
const AsyncInsuranceCompaniesReportComponent = Loadable({
  loader: () => import("../../routes/reports/insurance-companies"),
  loading: () => <RctPageLoader />,
});
const AsyncAgencyRatiosReportComponent = Loadable({
  loader: () => import("../../routes/reports/agency-ratios"),
  loading: () => <RctPageLoader />,
});
const AsyncAgencyActivityReportComponent = Loadable({
  loader: () => import("../../routes/reports/agency-activity"),
  loading: () => <RctPageLoader />,
});
const AsyncAgencyActivity2ReportComponent = Loadable({
  loader: () => import("../../routes/reports/agency-activity2"),
  loading: () => <RctPageLoader />,
});
const AsyncAgencyAdvancedReportsComponent = Loadable({
  loader: () => import("../../routes/reports/advanced-reports"),
  loading: () => <RctPageLoader />,
});
const AsyncInsurancesComparisonReportComponent = Loadable({
  loader: () => import("../../routes/reports/insurances-comparison"),
  loading: () => <RctPageLoader />,
});
const AsyncAgenciesHasDebtReportComponent = Loadable({
  loader: () => import("../../routes/reports/agencies-who-has-debt"),
  loading: () => <RctPageLoader />,
});

/* expenses */
const AsyncManageExpensesComponent = Loadable({
  loader: () => import("../../routes/expenses/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddExpenseComponent = Loadable({
  loader: () => import("../../routes/expenses/create"),
  loading: () => <RctPageLoader />,
});
const AsyncModifyExpenseComponent = Loadable({
  loader: () => import("../../routes/expenses/modify"),
  loading: () => <RctPageLoader />,
});
/* announcements */
const AsyncManageAnnouncementsComponent = Loadable({
  loader: () => import("../../routes/announcements/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddAnnouncementComponent = Loadable({
  loader: () => import("../../routes/announcements/create"),
  loading: () => <RctPageLoader />,
});
/*leads */
const AsyncManageLeadsComponent = Loadable({
  loader: () => import("../../routes/leads/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddLeadComponent = Loadable({
  loader: () => import("../../routes/leads/create"),
  loading: () => <RctPageLoader />,
});
const AsyncModifyLeadComponent = Loadable({
  loader: () => import("../../routes/leads/modify"),
  loading: () => <RctPageLoader />,
});
/*message requests */
const AsyncManageMessageRequestsComponent = Loadable({
  loader: () => import("../../routes/message-requests/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddMessageRequestComponent = Loadable({
  loader: () => import("../../routes/message-requests/create"),
  loading: () => <RctPageLoader />,
});
const AsyncModifyMessageRequestComponent = Loadable({
  loader: () => import("../../routes/message-requests/modify"),
  loading: () => <RctPageLoader />,
});
/*debt requests*/
const AsyncManageDebtRequestsComponent = Loadable({
  loader: () => import("../../routes/debt-requests/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddDebtRequestComponent = Loadable({
  loader: () => import("../../routes/debt-requests/create"),
  loading: () => <RctPageLoader />,
});
const AsyncModifyDebtRequestComponent = Loadable({
  loader: () => import("../../routes/debt-requests/modify"),
  loading: () => <RctPageLoader />,
});

const AsyncManageResidenceAppointmentsComponent = Loadable({
  loader: () => import("../../routes/residence-appointments/view-all"),
  loading: () => <RctPageLoader />,
});
/* bulk set ratios */
const AsyncManageBulkRatiosRequestsComponent = Loadable({
  loader: () => import("../../routes/bulk-ratios-requests/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddBulkRatiosRequestComponent = Loadable({
  loader: () => import("../../routes/bulk-ratios-requests/create"),
  loading: () => <RctPageLoader />,
});

/* debt sending schedules*/
const AsyncManageDebtSendingSchedulesComponent = Loadable({
  loader: () => import("../../routes/debtsending-schedules/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddDebtSendingSchedulesComponent = Loadable({
  loader: () => import("../../routes/debtsending-schedules/create"),
  loading: () => <RctPageLoader />,
});
const AsyncModifyDebtSendingSchedulesComponent = Loadable({
  loader: () => import("../../routes/debtsending-schedules/modify"),
  loading: () => <RctPageLoader />,
});

/*------invoices------*/
const AsyncManageInvoicesComponent = Loadable({
  loader: () => import("../../routes/invoices/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddInvoiceComponent = Loadable({
  loader: () => import("../../routes/invoices/create"),
  loading: () => <RctPageLoader />,
});
const AsyncModifyInvoiceComponent = Loadable({
  loader: () => import("../../routes/invoices/modify"),
  loading: () => <RctPageLoader />,
});
const AsyncCreateSupplierBillComponent = Loadable({
  loader: () => import("../../routes/invoices/create-supplier-bill"),
  loading: () => <RctPageLoader />,
});
/*sources*/
const AsyncManageSourcesComponent = Loadable({
  loader: () => import("../../routes/sources/view-all"),
  loading: () => <RctPageLoader />,
});
/*services*/
const AsyncManageServicesComponent = Loadable({
  loader: () => import("../../routes/services/view-all"),
  loading: () => <RctPageLoader />,
});
/*service-names*/
const AsyncManageServiceNamesComponent = Loadable({
  loader: () => import("../../routes/service-names/view-all"),
  loading: () => <RctPageLoader />,
});
/*payments*/
const AsyncManagePaymentsComponent = Loadable({
  loader: () => import("../../routes/payments/view-all"),
  loading: () => <RctPageLoader />,
});
/*payment-methods*/
const AsyncManagePaymentMethodsComponent = Loadable({
  loader: () => import("../../routes/payment-methods/view-all"),
  loading: () => <RctPageLoader />,
});
/* customers */
const AsyncManageCustomersComponent = Loadable({
  loader: () => import("../../routes/customers/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncAddCustomerComponent = Loadable({
  loader: () => import("../../routes/customers/create"),
  loading: () => <RctPageLoader />,
});
const AsyncModifyCustomerComponent = Loadable({
  loader: () => import("../../routes/customers/modify"),
  loading: () => <RctPageLoader />,
});
/* dashboard */
const AsyncViewInvoicesDashboardComponent = Loadable({
  loader: () => import("../../routes/invoices-dashboard/view-all"),
  loading: () => <RctPageLoader />,
});
/* acounts  & transaction */
const AsyncManageMoneyAccountsComponent = Loadable({
  loader: () => import("../../routes/money-accounts/view-all"),
  loading: () => <RctPageLoader />,
});
const AsyncManageMoneyTransactionsComponent = Loadable({
  loader: () => import("../../routes/money-accounts/view-transactions"),
  loading: () => <RctPageLoader />,
});

/* whatsapp devices */
const AsyncManageWhatsappDevicesComponent = Loadable({
  loader: () => import("../../routes/whatsapp-devices/view-all"),
  loading: () => <RctPageLoader />,
});

/* sms messages */
const AsyncManageSmsMessagesComponent = Loadable({
  loader: () => import("../../routes/sms-messages/view-all"),
  loading: () => <RctPageLoader />,
});

export {
  AsyncHomeComponent,
  AsyncTranslationsComponent,
  AsyncManageCompaniesComponent,
  AsyncAddCompanyComponent,
  AsyncManageInsuranceRequestsComponent,
  AsyncAddInsuranceRequestComponent,
  AsyncModifyCompanyComponent,
  AsyncManageAgenciesComponent,
  AsyncAddAgencyComponent,
  AsyncModifyAgencyComponent,
  AsyncAgencyRatioHistoryComponent,
  AsyncManageAgencyListsComponent,
  AsyncCreateAgencyListComponent,
  AsyncModifyAgencyListComponent,
  AsyncManageRolesComponent,
  AsyncAddRoleComponent,
  AsyncModifyRoleComponent,
  AsyncManageUsersComponent,
  AsyncAddUserComponent,
  AsyncModifyUserComponent,
  AsyncUsersLogsComponent,
  AsyncUsersProfileComponent,
  AsyncManageBalanceRequestsComponent,
  AsyncAddBalanceRequestComponent,
  AsyncModifyBalanceRequestComponent,
  AsyncSetPricesComponent,
  AsyncGetReceivedInsuranceRequestsComponent,
  AsyncManageProfitsComponent,
  AsyncManageFinancialRequestsComponent,
  AsyncSimpleFinancialRequestsComponent,
  AsyncExportedFinancialRequestsComponent,
  AsyncIncomingMoneyReportComponent,
  AsyncInsuranceCompaniesReportComponent,
  AsyncAgencyRatiosReportComponent,
  AsyncAgencyActivityReportComponent,
  AsyncManageExpensesComponent,
  AsyncAddExpenseComponent,
  AsyncModifyExpenseComponent,
  AsyncManageAnnouncementsComponent,
  AsyncAddAnnouncementComponent,
  AsyncManageLeadsComponent,
  AsyncAddLeadComponent,
  AsyncModifyLeadComponent,
  AsyncAgencyActivity2ReportComponent,
  AsyncAgencyAdvancedReportsComponent,
  AsyncManageDebtRequestsComponent,
  AsyncModifyDebtRequestComponent,
  AsyncAddDebtRequestComponent,
  AsyncManageMessageRequestsComponent,
  AsyncAddMessageRequestComponent,
  AsyncModifyMessageRequestComponent,
  AsyncManageResidenceAppointmentsComponent,
  AsyncInsurancesComparisonReportComponent,
  AsyncAgenciesHasDebtReportComponent,
  AsyncManageBulkRatiosRequestsComponent,
  AsyncAddBulkRatiosRequestComponent,
  AsyncAddDebtSendingSchedulesComponent,
  AsyncManageDebtSendingSchedulesComponent,
  AsyncModifyDebtSendingSchedulesComponent,
  /*invoices related */
  AsyncManageInvoicesComponent,
  AsyncAddInvoiceComponent,
  AsyncModifyInvoiceComponent,
  AsyncCreateSupplierBillComponent,
  /*sources related */
  AsyncManageSourcesComponent,
  /*services related */
  AsyncManageServicesComponent,
  /* service names */
  AsyncManageServiceNamesComponent,
  /*payments related */
  AsyncManagePaymentsComponent,
  /*payment methods */
  AsyncManagePaymentMethodsComponent,
  /* customers */
  AsyncManageCustomersComponent,
  AsyncAddCustomerComponent,
  AsyncModifyCustomerComponent,
  /* dashboard */
  AsyncViewInvoicesDashboardComponent,
  /* money accounts & transactions */
  AsyncManageMoneyAccountsComponent,
  AsyncManageMoneyTransactionsComponent,
  AsyncUsersViewAllUsersLoggedDevicesComponent,
  AsyncManageWhatsappDevicesComponent,
  /* sms messages */
  AsyncManageSmsMessagesComponent,
};
